module.exports = __webpack_public_path__ + "business.76037fa397c9de13eb6a";


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/assets/img/admin/business.jpg
// module id = ../../../../../src/assets/img/admin/business.jpg
// module chunks = monitor-agents.module